import { db } from "../Utils/firebase";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { authLogger } from "../Utils/logger";
import { toast } from "react-toastify";

export const updateUserOnlineStatus = async (user, isOnline) => {
    if (!user) {
        console.error("User not found");
        return;
    }

    try {
        const userRef = doc(db, "users", String(user.id));
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
            await updateDoc(userRef, {
                isOnline: isOnline,
                lastSeen: new Date(),
            });
            authLogger.info("User online status updated in Firestore", { userId: user.id });
        } else {
            await setDoc(userRef, {
                uid: user.id,
                name: user.full_name,
                email: user.email,
                phoneNumber: user.phone_number,
                profileImage: user.image ?? "",
                bio: user.bio ?? "",
                chatStatus: "available",
                isOnline: isOnline,
                lastSeen: new Date(),
                createdAt: new Date(),
                settings: {
                    lastSeenVisibility: true,
                    notifications: true,
                    readReceipts: true,
                },
                typing: false,
            });
            authLogger.info("New user document created in Firestore", { userId: user.id });
        }
    } catch (error) {
        authLogger.error("Firestore update/set error", error, { userId: user?.id });
        toast.error("An error occurred with user data. Please try again.");
    }
}

export const getFirestoreUsers = async (userIds) => {


    const users = [];
    for (const uid of userIds) {
        try {
            const userRef = doc(db, "users", String(uid));
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                users.push(userSnap.data());

            } else {
                console.warn("No Firestore document found for user ID:", uid);
            }
        } catch (error) {
            console.error("Error fetching Firestore user for ID:", uid, error);
        }
    }


    return users;
}